import { Button, Modal, Tag } from "antd";
import React, { useRef, useState } from "react";
import { dispatchtoast, getLocalStorageItem } from "../../../Utils";
import { PayFusionExpressPay } from "../../../ApiServices/Apifun";
import { Images } from "../../../Controller";
import { Globalendpoints } from "../../../ApiServices/global";
import OtpExpressPayout from "./OtpExpressPayFusion";
import useOtpHook from "../../../Hooks/useOtpHook";
import { useSelector } from "react-redux";
import { useReactToPrint } from "react-to-print";
const XPayFusionModal = ({
  isOpen,
  setIsOpen,
  details,
  transaction_type,
  mobile,
  remitterDetails,
  beneficiaryId,
}) => {
  const [inputValue, setInputValue] = useState("");
  const [purpose, setPurpose] = useState("");
  const [originalVal, setOriginalVal] = useState("");
  const [btnLoading, setBtnLoading] = useState(false);
  const [openVerifyModal, setOpenVerifyModal] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);
  const [otpuid, setOtpUid] = useState(null);
  const [hide, setHide] = useState(false);
  const [verifyPinScreen, setverifyPinScreen] = useState(false);
  const { handleChange, handleKeyUp, pin, inputRefs, resetPin } = useOtpHook(4);
  const [response, setResponse] = useState({});
  const profiledetail = useSelector((state) => state.B2B.profileDetail);

  const handleOk = () => {
    setIsOpen(false);
  };
  const handleCancel = () => {
    setIsOpen(false);
  };
  const formatNumberWithCommas = (value) => {
    return value.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };
  const handleChangeInput = (e) => {
    const sanitized = e.target.value.replace(/[^0-9.]/g, "");
    setOriginalVal(sanitized);
    const formattedValue = formatNumberWithCommas(sanitized);
    setInputValue(formattedValue);
  };

  const handlePay = () => {
    setBtnLoading(true);
    const formdata = new FormData();
    formdata.append("remitter_beneficiary_id", details.id);
    formdata.append("benificiary_account", details?.account_id);
    formdata.append("benificiary_ifsc", details?.ifsc);
    formdata.append("benificiary_name", details?.beneficiary);
    formdata.append("bank_id", details?.id);
    formdata.append("pin", pin.join(""));
    formdata.append("payment_purpose", purpose);
    formdata.append("transaction_type", transaction_type);
    formdata.append("latitude", getLocalStorageItem("latitude"));
    formdata.append("longitude", getLocalStorageItem("longitude"));
    formdata.append("amount", originalVal);
    formdata.append("remitter_mobile", mobile);

    PayFusionExpressPay(formdata)
      .then((res) => {
        if (res) {
          if (res.status) {
            dispatchtoast(res.message);
            setIsOpen(false);
            setHide(false);
            setResponse(res.data);
            setShowSuccess(true);
            setverifyPinScreen(false);
          } else {
            setIsOpen(false);
            setverifyPinScreen(false);
            dispatchtoast(res.message, true);
          }
        } else {
          dispatchtoast("Something went wrong", true);
        }
      })
      .catch((err) => console.log(err))
      .finally(() => setBtnLoading(false));
  };
  console.log(details, "details");
  const printRef = useRef(null);

  const handlePrint = useReactToPrint({
    content: () => printRef.current,
  });
  return (
    <>
      {!showSuccess ? (
        <>
          {" "}
          <Modal
            title={"Pay Amount"}
            footer={null}
            className={`shadow-normal ${hide ? "hidden" : ""}`}
            width={300}
            maskClosable={false}
            open={isOpen}
            onOk={handleOk}
            onCancel={handleCancel}
          >
            <div className="userDetail text-center font-semibold text-[16px]">
              <p className="underline underline-offset-2">
                {details?.account_id}
              </p>
              <p className="underline underline-offset-2">
                {details?.beneficiary}
              </p>
            </div>
            <div className="amount mt-4 font-bold text-center">
              <p className="text-3xl">₹</p>
              <input
                onChange={(e) => handleChangeInput(e)}
                value={inputValue}
                placeholder="0"
                className="border-none w-full text-lg text-center"
              />
            </div>
            <div className="mt-3">
              <select
                className="w-full border border-gray-300 rounded-lg  text-sm"
                value={purpose}
                onChange={(e) => setPurpose(e.target.value)}
              >
                <option value="">----Select Purpose of Payment----</option>
                <option value="Education Fees">Education Fees</option>
                <option value="Rent">Rent</option>
                <option value="Commission">Commission</option>
                <option value="Salary">Salary</option>
                <option value="Hospital">Hospital</option>
                <option value="Vendor Payment">Vendor Payment</option>
              </select>
            </div>
            <Button
              onClick={() => setverifyPinScreen(true)}
              // loading={btnLoading}
              disabled={!inputValue}
              className="w-full mt-28 bg-primary hover:bg-primaryhover text-bswhite rounded-sm border-none "
            >
              Pay
            </Button>
          </Modal>
        </>
      ) : (
        <Modal
          title={"Transaction Receipt"}
          footer={null}
          closeIcon={false}
          className={`shadow-normal ${hide ? "hidden" : ""}`}
          width={800}
          maskClosable={false}
          open={isOpen}
          onOk={handleOk}
          onCancel={handleCancel}
        >
          {/* PRINT AREA */}
          <div
            ref={printRef}
            className="bg-white text-[12px] border-2 border-blue-700 p-3"
          >
            {/* TOP SECTION */}
            <div className="flex justify-center items-center mb-2">
              <img src={Images?.WebsiteLogo} className="h-12" alt="Logo" />
            </div>
            <div className="flex justify-between">
              {/* LEFT */}
              <div className="space-y-1">
                <p>
                  <b>Shop Name :{profiledetail?.business_name}</b>
                </p>
                <p>
                  <b>Mobile No :{profiledetail?.mobile}</b>
                </p>
                <p>
                  <b>Sender Name :{remitterDetails[0]?.name}</b>
                </p>
                <p>
                  <b>Sender No :{remitterDetails[0]?.mobile}</b>
                </p>
              </div>

              {/* RIGHT */}
              <div className="space-y-1 text-right">
                <p>
                  <b>Beneficiary :</b> {beneficiaryId?.beneficiary}
                </p>
                <p>
                  <b>Bank Name :{beneficiaryId?.bank_name}</b>
                </p>
                <p>
                  <b>Account No :{beneficiaryId?.account_id}</b>
                </p>
                <p>
                  <b>Date :</b> {new Date().toLocaleString()}
                </p>
              </div>
            </div>

            {/* DIVIDER */}
            <div className="border-t-2 border-blue-700 my-2"></div>

            {/* TRANSACTION TABLE */}
            <table className="w-full text-center border-collapse">
              <thead>
                <tr className="border-b-2 border-blue-700">
                  <th className="p-1">TID</th>
                  <th className="p-1">MODE</th>
                  <th className="p-1">Status</th>
                  <th className="p-1">UTR No</th>
                  <th className="p-1 text-right">Amount</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td className="p-1">{response.transaction_id}</td>
                  <td className="p-1">{transaction_type}</td>
                  <td className="p-1">
                    {response.status === "1" ? (
                      <Tag color="green">Success</Tag>
                    ) : response.status === "2" ? (
                      <Tag color="red">Failed</Tag>
                    ) : (
                      <Tag color="yellow">Pending</Tag>
                    )}
                  </td>
                  <td className="p-1">{response.utr ?? "--"}</td>
                  <td className="p-1 text-right font-semibold">
                    ₹ {originalVal}
                  </td>
                </tr>
              </tbody>
            </table>

            {/* TOTAL */}
            <div className="flex justify-end border-t-2 border-blue-700 mt-2 pt-1">
              <p className="font-semibold">Total &nbsp; ₹ {originalVal}</p>
            </div>
          </div>

          {/* ACTIONS */}
          <div className="flex gap-2 mt-4">
            <Button className="w-full" onClick={() => setIsOpen(false)}>
              Close
            </Button>

            <Button className="w-full" onClick={handlePrint}>
              Print / Download
            </Button>
          </div>
        </Modal>
      )}

      {openVerifyModal && (
        <OtpExpressPayout
          isOpen={openVerifyModal}
          setIsOpen={setOpenVerifyModal}
          setShowSuccess={setShowSuccess}
          setResponse={setResponse}
          setXpaymodal={setIsOpen}
          setHide={setHide}
          otherFields={{
            otp_uid: otpuid,
            latitude: getLocalStorageItem("latitude"),
            longitude: getLocalStorageItem("longitude"),
            amount: originalVal,
            mobile: mobile,
            ...details,
          }}
          endpoint={Globalendpoints.payAmount}
        />
      )}
      {verifyPinScreen && (
        <Modal
          title="Enter PIN"
          open={verifyPinScreen}
          onCancel={() => {
            setverifyPinScreen(false);
            resetPin();
          }}
          footer={false}
        >
          <div className="  rounded-3xl shadow-normal bg-white p-5">
            <div className="header flex flex-col justify-center items-center">
              <p className="text-[15px] mt-3 text-gray-500">Verify PIN</p>
            </div>
            <div className=" mt-5 flex justify-center items-center">
              {[1, 2, 3, 4].map((i, index) => {
                return (
                  <input
                    key={index}
                    ref={inputRefs[index]}
                    type="text"
                    maxLength={1}
                    className="w-[25px] otpinput xs:w-[35px] sm:w-[35px] md:w-[40px] text-bsblackrgb bg-gray-100 h-8  mx-1 border-none  text-center"
                    value={pin[index]}
                    onChange={(e) => handleChange(index, e.target.value)}
                    onKeyUp={(e) => handleKeyUp(index, e)}
                  />
                );
              })}
            </div>
            <Button
              loading={btnLoading}
              onClick={() => pin.length === 4 && handlePay()}
              className={`SignInBtn w-full ${
                pin.length === 4 ? "cursor-pointer" : "cursor-not-allowed"
              }  mt-4 ${
                pin.length === 4 ? "bg-primary" : "bg-bsgray"
              }  flex justify-center border-none items-center h-12 mt-10 rounded-full text-white text-[12px] font-bold`}
            >
              <p>Pay</p>
            </Button>
          </div>
        </Modal>
      )}
      {/* {openReceiptDrawer &&
      <ReportDrawer
        title={"Payments Receipt"}
        open={openReceiptDrawer}
        setOpen={setOpenReceiptDrawer}
        content={<Content />}
      />
} */}
    </>
  );
};

export default XPayFusionModal;
